import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, Link } from "react-router-dom";
import Logo from "../../assets/new images/logo.png";

export default function EmailVerificationStatus() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    navigate("/login");
  };

  return (
    <main className="relative min-h-screen w-full grid place-items-center overflow-hidden">
      {/* soft background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#FFF4EE] via-[#FFF8F4] to-white" />
      <div className="pointer-events-none absolute -left-24 -top-24 w-[38rem] h-[38rem] rounded-full bg-[#FFB899]/25 blur-3xl" />
      <div className="pointer-events-none absolute -right-28 bottom-0 w-[42rem] h-[42rem] rounded-full bg-[#FFD9C9]/30 blur-3xl" />

      <div className="relative w-11/12 md:w-4/5 lg:w-1/2 mx-auto max-w-6xl px-5 py-10">
        {/* Logo */}
        <div className="w-full flex justify-center mb-8">
          <div className="w-16 h-16 grid place-items-center rounded-2xl">
            <img src={Logo} className="h-20 w-20" alt="Cabil logo" />
          </div>
        </div>

        {/* Heading */}
        <div className="text-center mb-6">
          <h1 className="text-3xl md:text-[32px] font-semibold text-[#2A3A54]">
            {t("emailVerification.heading")}
          </h1>
          <p className="mt-2 text-sm text-[#6B7280]">
            {t("emailVerification.subheading")}
          </p>
        </div>

        {/* Status card */}
        <div className="max-w-xl mx-auto">
          <div className="rounded-2xl border border-[#F5CDBB] bg-white/90 shadow-[0_10px_40px_-15px_rgba(17,24,39,0.15)] p-6 md:p-8">
            {/* Email verified */}
            <div className="flex flex-col md:flex-row md:items-center gap-3 mb-4 pt-3 pb-3">
              <div className="flex items-center justify-center w-10 h-10 rounded-full bg-emerald-50">
                <span className="text-xl">✅</span>
              </div>
              <div className="text-left">
                <p className="text-sm font-semibold text-emerald-600">
                  {t("emailVerification.verifiedTitle")}
                </p>
                <p className="text-sm text-gray-600">
                  {t("emailVerification.verifiedDesc")}
                </p>
              </div>
            </div>

            {/* Token expired */}
            <div className="flex flex-col md:flex-row md:items-center gap-3 mt-4 pb-3 border-t border-gray-100 pt-4">
              <div className="flex items-center justify-center w-10 h-10 rounded-full p-4 bg-red-50">
                <span className="text-xl">⏰</span>
              </div>
              <div className="text-left">
                <p className="text-sm font-semibold text-red-600">
                  {t("emailVerification.expiredTitle")}
                </p>
                <p className="text-sm text-gray-600">
                  {t("emailVerification.expiredDesc")}
                </p>
              </div>
            </div>

            {/* Actions */}
            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <button
                onClick={handleGoToLogin}
                className="flex-1 inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:from-[#2A3A54] hover:to-[#EE5F2B] transition"
              >
                {t("emailVerification.goToLogin")}
              </button>

              <Link
                to="/"
                className="flex-1 inline-flex items-center justify-center rounded-xl border border-[#EE5F2B]/30 bg-white px-4 py-2.5 text-sm font-medium text-[#2A3A54] hover:bg-[#FFF4EE] transition"
              >
                {t("emailVerification.backToHome")}
              </Link>
            </div>
          </div>
        </div>

        {/* footer text */}
        <div className="text-center mt-8">
          <p className="text-xs text-gray-500">
            {t("emailVerification.footerNote")}
          </p>
        </div>
      </div>
    </main>
  );
}
